import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.scss';

const COOKIE_CONSENT_KEY = 'cookieConsent';
const ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000;

const CookieConsent: React.FC = () => {
  const [ isVisible, setIsVisible ] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (consent) {
      try {
        const { timestamp } = JSON.parse(consent);
        const now = new Date().getTime();
        // 1年以内であればバナーを表示しない
        if (now - timestamp < ONE_YEAR_IN_MS) {
          return;
        }
      } catch (error) {
        // パースエラーの場合は再度表示
        console.error('Failed to parse cookie consent:', error);
      }
    }
    // 同意がない、または期限切れの場合は表示
    setIsVisible(true);
  }, []);

  const handleAccept = () => {
    const consent = {
      accepted: true,
      timestamp: new Date().getTime()
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="form cookie-consent__content">
        <p>
          当サイトでは、サービスの向上とユーザー体験の最適化のためにCookieを使用しています。
          利用を継続するには<Link to="/cookie_policy">クッキーポリシー</Link>に同意をしてください。
        </p>
        <button
          className="w_orangebtn"
          onClick={ handleAccept }
          type="button"
        >
          同意する
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
